"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
var createError_1 = require("./createError");
var projectInfo_1 = require("./projectInfo");
function assert(assertion) {
    if (assertion) {
        return;
    }
    var projectInfo = projectInfo_1.getProjectInfo();
    var projectGithub = projectInfo.projectGithub;
    var errMsg = "[Internal Error] Something unexpected happened.";
    if (projectGithub) {
        errMsg += " Please open a new issue at " + projectGithub + "/issues/new and include this error stack.";
    }
    var err = createError_1.createError(errMsg);
    throw err;
}
exports.assert = assert;
//# sourceMappingURL=assert.js.map